import React from "react";
import { Facebook, Twitter, YouTube, LinkedIn, Instagram } from "@material-ui/icons";

function Footer() {
    const SocialStyle = "rounded-full border-2 border-whit lg:p-2 p-1 mr-[1.1rem] lg:mr-[5rem]"
  return (
    <div className=" footer flex flex-col items-center justify-start lg:px-[5rem] bg-black h-screen full min-h-[40rem] lg:min-h-[45rem] pt-[20rem] lg:pt-[18rem] mt-[-20rem] relative z-[-1]">

    </div>
  );
}

export default Footer;
